/**
 * Check to see if user is super admin
 */

const isSuperAdminUser = (user) => {
  return user.isSuperAdmin
}

export { isSuperAdminUser }
